import React from 'react';
import clsx from 'clsx';

import {Typography} from '@nur-portal/ui-kit';

import {getIconUrl} from '../../../services/content-type/share-modal';

import styles from './share-menu.module.css';

const WHATSAPP = 'whatsapp';
const FACEBOOK = 'facebook';
const TELEGRAM = 'telegram';
const VK = 'vkontakte';
const TWITTER = 'twitter';

export const LIST_SHARE_NETWORKS = [
  {
    type: WHATSAPP,
    name: 'Whatsapp',
    baseUrl: 'whatsapp://send',
    utmSource: 'whatsapp',
    imageUrl: {
      default: getIconUrl('social-icons/new/whatsapp'),
      custom: getIconUrl('social-icons/new/whatsapp-dark')
    }
  },
  {
    type: FACEBOOK,
    name: 'Facebook',
    baseUrl: 'https://www.facebook.com/sharer/sharer.php',
    utmSource: 'facebook',
    imageUrl: {
      default: getIconUrl('social-icons/new/facebook'),
      custom: getIconUrl('social-icons/new/facebook-dark')
    }
  },
  {
    type: TELEGRAM,
    name: 'Telegram',
    baseUrl: 'https://t.me/share/url',
    utmSource: 'telegram',
    imageUrl: {
      default: getIconUrl('social-icons/new/telegram'),
      custom: getIconUrl('social-icons/new/telegram-dark')
    }
  },
  {
    type: VK,
    name: 'ВКонтакте',
    baseUrl: 'https://vk.com/share.php',
    utmSource: 'vk',
    imageUrl: {
      default: getIconUrl('social-icons/new/vkontakte'),
      custom: getIconUrl('social-icons/new/vkontakte-dark')
    }
  },
  {
    type: TWITTER,
    name: 'X (Twitter)',
    baseUrl: 'https://twitter.com/share',
    utmSource: 'twitter',
    imageUrl: {
      default: getIconUrl('social-icons/new/x'),
      custom: getIconUrl('social-icons/new/x-dark')
    }
  }
];

const getEncodedUrl = ({utmMedium, link, utmSource}) =>
  encodeURI(`${link}?utm_medium=${utmMedium}&utm_source=${utmSource}`);

export const getShareUrl = ({url, title, type, baseUrl, utmMedium, utmSource}) => {
  const encodedTitle = encodeURI(title);
  const encodedUrl = getEncodedUrl({utmMedium, link: url, utmSource});

  switch (type) {
    case WHATSAPP:
      return `${baseUrl}?text=${encodedTitle} ${encodedUrl}`;
    case FACEBOOK:
      return `${baseUrl}?u=${encodedUrl}`;
    case TELEGRAM:
    case TWITTER:
      return `${baseUrl}?url=${encodedUrl}&text=${encodedTitle}`;
    case VK:
      return `${baseUrl}?url=${encodedUrl}`;
    default:
      return '';
  }
};

const ShareMenu = ({
  isCustom = false,
  url,
  utmMedium,
  title
}) => {
  const onCopyLinkClick = e => {
    const $target = e.currentTarget;

    import(/* webpackChunkName: "copy-to-clipboard" */ '../../../services/content-type/copy-to-clipboard')
      .then(module => {
        module.default(url, $target, 'trend-link');
      });
  };

  return (
    <>
      {isCustom && (
        <Typography variant="text-14" className={styles.text}>
          Поделиться:
        </Typography>
      )}
      <ul className={styles.list}>
        <li
          className={clsx('share-menu__button', styles.item)}
          onClick={onCopyLinkClick}
          data-platform="copy"
          data-url={url}
        >
          <img
            className={styles.itemImage}
            src={isCustom ? getIconUrl('social-icons/new/copy-link-dark') : getIconUrl('social-icons/new/copy-link')}
            alt="Copy link"
          />
        </li>
        {LIST_SHARE_NETWORKS.map(item => {
          const shareUrl = getShareUrl({...item, url, utmMedium, title});
          const imageUrl = isCustom ? item.imageUrl.custom : item.imageUrl.default;

          return (
            <li className={styles.item} key={item.name}>
              <a
                href={shareUrl}
                rel="nofollow noopener noreferrer"
                target="_blank"
                className={clsx('share-menu__button', styles.itemLink)}
                data-url={url}
                data-platform={item.type}
              >
                <img src={imageUrl} alt={item.name} className={styles.itemImage} />
              </a>
            </li>
          );
        })}
      </ul>
    </>
  );
};

export {ShareMenu};
